var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182.6 217",
    style: {
      enableBackground: "new 0 0 182.6 217"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,54c-9.2,5.2-16.3,12.4-21.4,21.8c-5.1,9.4-7.6,20.2-7.6,32.4c0,12.2,2.5,23,7.6,32.4 c5.1,9.4,12.2,16.7,21.4,21.8c9.2,5.2,19.7,7.7,31.4,7.7c10,0,19.2-2.1,27.7-6.3V52.6c-8.5-4.2-17.7-6.3-27.7-6.3 C143.1,46.3,132.6,48.9,123.4,54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,206.6c-18.1-9.6-32.3-23-42.6-40.1c-10.3-17.1-15.5-36.6-15.5-58.2S37.7,67.2,48,50 C58.3,32.9,72.5,19.5,90.6,9.9c8-4.2,16.4-7.5,25.3-9.9H0v216.7l0,0.3h117.8C108.2,214.6,99.1,211.2,90.6,206.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.aa80e9bb6577c5b1bbffbaa6b74cb0c9.svg";
export { ForwardRef as ReactComponent };